import * as React from "react";
import type { Obj } from "../../client_types";
import useEffectOnce from "../customHook/useEffectOnce";

interface IProps {
  children: React.ReactNode;
}
const Context = React.createContext<Obj>({});
const reducer = (state: Obj, action: Obj): Obj => {
  const updated = { ...state, ...action };

  if (action.__CLEAR_ALL) {
    localStorage.clear();
    return {};
  }
  for (const [key, value] of Object.entries(updated)) {
    if (value !== null && value !== undefined) {
      localStorage.setItem(key, value.toString());
    } else {
      localStorage.removeItem(key);
    }
  }

  return updated;
};

const Provider = ({ children }: IProps) => {
  const [state, dispatch] = React.useReducer(reducer, {});

  useEffectOnce(() => {
    const obj: Obj = {};
    for (const [key, value] of Object.entries(localStorage)) {
      obj[key] = value;
    }
    dispatch(obj);
  }, []);

  return (
    <Context.Provider value={{ state, dispatch }}>{children}</Context.Provider>
  );
};

export default Provider;
export { Context as context };
